<div class="flex flex-col w-full h-full">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      {{ (data.job ? 'services.dialog.editJob.edit' : 'services.dialog.editJob.new') | transloco }}
    </div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto p-6 sm:p-8">
    @if (dtypeForm) {
      <dtype-component-list [dtypeForm]="dtypeForm" [isUpdate]="data.update">
      </dtype-component-list>
    }
  </div>

  <div class="flex justify-end items-end py-4">
    <button mat-stroked-button  (click)="closeDialog()" color="warn" class="mr-5">
      {{ 'cancel' | transloco }}
    </button>
    <button mat-stroked-button color="primary" class="mr-5" (click)="save()">
      {{ 'saveChanges' | transloco }}
    </button>
  </div>

</div>